import { BaseService } from '@services/base.service';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { PermissionsService } from '@services/permissions.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  userId: number;
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  form = new FormGroup({
    oldPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  constructor(
    private baseService: BaseService,
    private dialog: MatDialog,
    private permissionService: PermissionsService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
  ) {

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.permissionService.userInfo.subscribe({
      next: userInfo => {
        this.userId = userInfo.id;
      }
    })
  }
  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return
    }
    if (this.form.get('newPassword').getRawValue() !== this.form.get('confirmPassword').getRawValue()) {
      this.form.get('confirmPassword').setErrors({ confirmPasswordValidator: true })
      return
    }
    this.baseService.getChangePassword(this.userId, this.form.getRawValue()).subscribe({
      next: response => {
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Đổi mật khẩu thành công',
            content: '',
            type: 'success',
          },
        });
        this.dialogRef.close();
      }
    })
    // console.log(this.form.get('confirmPassword').errors)
    // this.form.get('oldPassword').getError();
  }
  getErrorMessage(formControl) {
    if (this.form.get('newPassword').getRawValue() !== this.form.get('confirmPassword').getRawValue()) {
      this.form.get('confirmPassword').setErrors({ confirmPasswordValidator: true })
    }
    if (formControl.hasError('required')) {
      return 'Không được bỏ trống';
    }
    if (formControl.hasError('minlength')) {
      return 'Nhập ít nhất 8 ký tự';
    }
    // return formControl.hasError('minlength') ? 'Nhập ít nhất 8 ký tự' : '';
    if (formControl.hasError('confirmPasswordValidator')) {
      return 'Nhập lại mật khẩu';
    }
    return '';
  }
}
